<script>
import { loadAssetWhiteLabel } from '@composables/utils/loadAsset'
import { appImg, formButton } from 'tb-design_system-web'
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'

import RegisterLayout from '@/components/shared/registerLayout.vue'
import { validateStepAccess } from '@/composables/utils/onboardingGuards'
import { getPlatformFromUrl, platformWhiteLabel } from '@/composables/utils/useWhitelabelService.js'
import { useOnboardingStore } from '@/stores/onboarding'

export default {
  name: 'FinishSuccess',
  components: {
    RegisterLayout,
    formButton,
    appImg
  },
  setup() {
    const router = useRouter()
    const onboardingStore = useOnboardingStore()
    const platform = getPlatformFromUrl()

    const isPJ = onboardingStore.typeClient === 'PJ'

    const plataformImg = new URL('@/assets/img/svg/plataform.svg', import.meta.url).href

    const onSubmitAction = () => {
      const url = platformWhiteLabel(platform, 'platformUrlRedirection')
      window.location.href = url
    }

    onMounted(() => {
      const requiredType = isPJ ? 'PJ' : 'PF'
      const requiredSteps = isPJ ? [1, 2, 3] : [1, 2, 3]
      validateStepAccess(onboardingStore, requiredType, requiredSteps, router)
      onboardingStore.resetState()
    })

    return {
      plataformImg,
      onSubmitAction,
      loadAssetWhiteLabel
    }
  }
}
</script>

<template>
  <RegisterLayout>
    <div class="col-12 col-md-9 d-flex align-items-center">
      <div class="w-100">
        <div class="row d-flex justify-content-center">
          <div class="col-12 col-md-6 col-lg-5 d-flex flex-column align-items-center">
            <app-img
              class="img-responsive mb-5"
              :src="loadAssetWhiteLabel('logo.svg')"
              alt="logo"
              height="30"
            />

            <div class="col-12 d-flex justify-content-center mb-3">
              <img :src="plataformImg" width="140" height="140" />
            </div>

            <div class="col-12 text-center">
              <h4 class="text-center mb-4">
                <b
                  >Obrigado por completar o seu cadastro, sua conta vai ficar pronta em até 1 dia
                  útil.</b
                >
              </h4>

              <small> Vamos enviar um e-mail assim que nossa analise for concluida. </small>

              <form-button
                class="col-12 form-input"
                title="Acessar plataforma"
                @clicked="onSubmitAction"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </RegisterLayout>
</template>

<style scoped lang="scss">
.box {
  border-radius: 9px;
  background-color: #140617;
  color: #ffffff;
}
</style>
